import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  LiveBroadIcon,
  TvStreamIcon,
  VideoStreamIcon,
  MusicStreamIcon,
} from "../../../../app-constants";

function Techsolution(props) {
  return (
    <div className="techsolution tech_music_solution p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>Types of Streaming Apps Our Music App Developers Can Create</h2>
            <p>
              If you are continuously thinking about how to build a
              live-streaming app, our music app developers can assist you.
            </p>
            <p>
              Our expert team of specialized streaming app developers knows how
              to create various types of video streaming apps that are currently
              popular.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <div className="solution_box">
              <div className="solution_box_items">
                <div className="item_icon">{LiveBroadIcon}</div>
                <div className="item_txt">
                  <h5>Live Broadcasting Apps</h5>
                  <p>
                    These streaming apps help users to record and stream videos
                    at the same time. Facebook Live, Periscope and Twitch are
                    some popular examples of live broadcasting apps. Tekrevol
                    can help you build a similar app for helping your users to
                    watch live gameplays, talk to their communities and more.
                  </p>
                </div>
              </div>
              <div className="solution_box_items">
                <div className="item_icon">{MusicStreamIcon}</div>
                <div className="item_txt">
                  <h5>Music Streaming Apps</h5>
                  <p>
                    From Pandora to Spotify, music streaming apps have
                    revolutionized the entire audio and music industry. Now
                    users don’t need to download music onto their device
                    anymore. They can pick and choose anything to play via
                    streaming music apps. We can build a similar app for you
                    equipped with all the right features.
                  </p>
                </div>
              </div>
              <div className="solution_box_items">
                <div className="item_icon">{VideoStreamIcon}</div>
                <div className="item_txt">
                  <h5>Video On Demand Streaming Apps</h5>
                  <p>
                    Netflix has become a rage these days because it ended the
                    monotony of forced programming on to the user. Now, the user
                    can use its own Video on Demand Apps and build its own
                    programming schedule without downloading anything on to its
                    device. Our app development team can build a VOD streaming
                    app for you that can easily allow users to play, rewind,
                    pause videos, and create playlists, view recommendations and
                    much more.
                  </p>
                </div>
              </div>
              <div className="solution_box_items">
                <div className="item_icon">{TvStreamIcon}</div>
                <div className="item_txt">
                  <h5>TV Live Streaming Apps</h5>
                  <p>
                    Just like everything else, users also want to watch TV via
                    streaming it live these days. We have an expert team on
                    board that can build a live TV streaming app for your
                    channel that allows your users to watch any of your
                    broadcasts in HD quality anywhere they want.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Techsolution;
